import { render, staticRenderFns } from "./workpackage-ao-extracts.vue?vue&type=template&id=d11f6af4&scoped=true"
import script from "./workpackage-ao-extracts.vue?vue&type=script&lang=js"
export * from "./workpackage-ao-extracts.vue?vue&type=script&lang=js"
import style0 from "./workpackage-ao-extracts.vue?vue&type=style&index=0&id=d11f6af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11f6af4",
  null
  
)

export default component.exports